const normalizeHostname = (input) => {
  const value = String(input || '').trim().toLowerCase()
  if (!value) {
    return ''
  }
  try {
    const url = value.startsWith('//')
      ? new URL(`https:${value}`)
      : new URL(/^[a-z][a-z\d+.-]*:\/\//i.test(value) ? value : `https://${value}`)
    return url.hostname.replace(/\.+$/, '')
  } catch {
    return ''
  }
}

export const normalizeCdnImageIdentifierMap = (input) => {
  if (!input || typeof input !== 'object' || Array.isArray(input)) {
    return {}
  }
  const result = {}
  Object.entries(input).forEach(([domain, identifier]) => {
    const hostname = normalizeHostname(domain)
    const value = typeof identifier === 'string' ? identifier.trim() : ''
    if (hostname && value) {
      result[hostname] = value
    }
  })
  return result
}

export const resolveCdnImageIdentifier = (input, mapping) => {
  const value = String(input || '').trim()
  if (!value || (!/^https?:\/\//i.test(value) && !value.startsWith('//'))) {
    return ''
  }
  try {
    const url = new URL(value.startsWith('//') ? `https:${value}` : value)
    return mapping[normalizeHostname(url.hostname)] || ''
  } catch {
    return ''
  }
}

const hasQueryIdentifier = (base, identifier) => {
  const queryIndex = base.indexOf('?')
  if (queryIndex < 0) {
    return false
  }
  const existing = new URLSearchParams(base.slice(queryIndex + 1))
  const expected = new URLSearchParams(identifier)
  return Array.from(expected.entries()).every(([key, value]) => existing.getAll(key).includes(value))
}

export const appendCdnImageIdentifier = (input, identifier) => {
  const value = String(input || '').trim()
  const imageIdentifier = String(identifier || '').trim()
  if (!value || !imageIdentifier) {
    return value
  }

  const hashIndex = value.indexOf('#')
  const base = hashIndex >= 0 ? value.slice(0, hashIndex) : value
  const hash = hashIndex >= 0 ? value.slice(hashIndex) : ''

  if (imageIdentifier.startsWith('?') || imageIdentifier.startsWith('&')) {
    const rawIdentifier = imageIdentifier.replace(/^[?&]+/, '')
    if (!rawIdentifier || hasQueryIdentifier(base, rawIdentifier)) {
      return value
    }
    const prefix = base.includes('?') ? '&' : '?'
    return `${base}${prefix}${rawIdentifier}${hash}`
  }

  const queryIndex = base.indexOf('?')
  const pathPart = queryIndex >= 0 ? base.slice(0, queryIndex) : base
  const queryPart = queryIndex >= 0 ? base.slice(queryIndex) : ''
  if (pathPart.endsWith(imageIdentifier)) {
    return value
  }
  return `${pathPart}${imageIdentifier}${queryPart}${hash}`
}
